import React, { useRef, useState } from 'react';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

import { TypoPoppins } from '../../../Components/Typo';

import { ORDER_STATUS } from '../../../Constant/Enums';

import { useAuthContext } from '../../../Context/AuthContext';

import JobRequestsCard from './JobRequestsCard';

import useProfessionalOrders from './useProfessionalOrders';
import { dummyOrdersData } from '../../../lib/DummyData/professionalPage';

function JobRequestsResponseSection() {
  // const { user } = useAuthContext();

  // const { orders, updateOrders } = useProfessionalOrders(ORDER_STATUS.AWAIT_APPROVAL, user.userID);
  // const { orders, updateOrders } = useProfessionalOrders();

  const orders = dummyOrdersData;
const updateOrders = () => {}; // no-op for now


  const [isScrollTopVisible, setIsScrollTopVisible] = useState(false);

  const scrollableContainer = useRef();

  function handleScrollTopVisibility(event) {
    const shouldScrollTopVisible = event.currentTarget.scrollTop > 100;
    if (shouldScrollTopVisible !== isScrollTopVisible)
      setIsScrollTopVisible(shouldScrollTopVisible);
  }

  function handleScrollTop() {
    scrollableContainer.current.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <>
      <Box position='relative' width='fit-content' mx={{ md: 'initial', xs: 'auto' }}>
        <Stack
          gap={3}
          px={2}
          pb={2}
          maxHeight={500}
          overflow='auto'
          onScroll={handleScrollTopVisibility}
          ref={scrollableContainer}>
          {orders.length > 0 &&
            orders.map(cardProps => (
              <Box maxWidth={550} key={cardProps.referenceId}>
                <JobRequestsCard data={cardProps} updateParentJobsRequests={updateOrders} />
              </Box>
            ))}

          {isScrollTopVisible && (
            <Fab
              size='small'
              sx={{ position: 'absolute', right: '16px', bottom: '8px' }}
              onClick={handleScrollTop}>
              <ArrowUpwardIcon />
            </Fab>
          )}
        </Stack>
      </Box>

      {orders.length === 0 && (
        <TypoPoppins
          fontWeight={400}
          color='text.secondary'
          variant='h6'
          variantMapping={{ h6: 'p' }}>
          No items found
        </TypoPoppins>
      )}
    </>
  );
}

export default JobRequestsResponseSection;
